import { createSelector } from 'redux-bundler';

import BootScheduleRun from '../models/boot_schedule_run';

export default {
  name: 'bootScheduleRuns',

  getReducer: () => {
    const initialData = {
      data: null,
      loading: false,
      bootScheduleId: null,
      expandedRunId: null,
      expandedRun: null,
      loadingExpandedRun: false,
    };

    return (state = initialData, { type, payload }) => {
      if (type === 'FETCH_BOOT_SCHEDULE_RUNS_START') {
        return { ...state, loading: true };
      }
      if (type === 'FETCH_BOOT_SCHEDULE_RUNS_SUCCESS') {
        return {
          ...state,
          loading: false,
          data: payload.results,
          bootScheduleId: payload.bootScheduleId,
        };
      }
      if (type === 'FETCH_BOOT_SCHEDULE_RUN_DETAIL_START') {
        return {
          ...state,
          loadingExpandedRun: true,
          expandedRunId: payload.runId,
        };
      }
      if (type === 'FETCH_BOOT_SCHEDULE_RUN_DETAIL_SUCCESS') {
        return {
          ...state,
          loadingExpandedRun: false,
          expandedRun: payload.result,
        };
      }
      if (type === 'COLLAPSE_BOOT_SCHEDULE_RUN') {
        return {
          ...state,
          expandedRunId: null,
          expandedRun: null,
        };
      }
      if (type === 'RESET_BOOT_SCHEDULE_RUNS') {
        return { ...initialData };
      }
      if (type === 'RESET_ACTIVE_BOOT_SCHEDULE') {
        return { ...initialData };
      }
      return state;
    };
  },

  doFetchBootScheduleRuns:
    bootScheduleId =>
    async ({ dispatch, getState, store }) => {
      const authenticatedUser = store.selectAuthenticatedUser(getState());
      if (
        !authenticatedUser ||
        !authenticatedUser.isAuthorized('boot.schedule.run.index')
      ) {
        return;
      }
      dispatch({ type: 'FETCH_BOOT_SCHEDULE_RUNS_START' });
      const response = await BootScheduleRun.where({
        boot_schedule_id: bootScheduleId,
      })
        .order({ fired_at: 'desc' })
        .per(20)
        .all();
      dispatch({
        type: 'FETCH_BOOT_SCHEDULE_RUNS_SUCCESS',
        payload: { results: response.data, bootScheduleId },
      });
    },

  doToggleBootScheduleRunDetail:
    runId =>
    async ({ dispatch, getState, store }) => {
      const state = getState();
      if (state.bootScheduleRuns.expandedRunId === runId) {
        dispatch({ type: 'COLLAPSE_BOOT_SCHEDULE_RUN' });
        return;
      }
      const authenticatedUser = store.selectAuthenticatedUser(state);
      if (
        !authenticatedUser ||
        !authenticatedUser.isAuthorized('boot.schedule.run.show')
      ) {
        return;
      }
      dispatch({
        type: 'FETCH_BOOT_SCHEDULE_RUN_DETAIL_START',
        payload: { runId },
      });
      const response = await BootScheduleRun.includes([
        { workstation_boots: 'workstation' },
      ]).find(runId);
      dispatch({
        type: 'FETCH_BOOT_SCHEDULE_RUN_DETAIL_SUCCESS',
        payload: { result: response.data },
      });
    },

  selectBootScheduleRunRaw: state => state.bootScheduleRuns,
  selectBootScheduleRunData: state => state.bootScheduleRuns.data || [],
  selectBootScheduleRunLoading: state => state.bootScheduleRuns.loading,
  selectExpandedRunId: state => state.bootScheduleRuns.expandedRunId,
  selectExpandedRun: state => state.bootScheduleRuns.expandedRun,
  selectLoadingExpandedRun: state => state.bootScheduleRuns.loadingExpandedRun,

  reactShouldFetchBootScheduleRuns: createSelector(
    'selectActiveBootSchedule',
    'selectBootScheduleRunRaw',
    (activeBootSchedule, raw) => {
      if (!activeBootSchedule || raw.loading) return null;
      if (raw.bootScheduleId === activeBootSchedule.id) return null;
      return {
        actionCreator: 'doFetchBootScheduleRuns',
        args: [activeBootSchedule.id],
      };
    },
  ),
};
